export const homeIs = {
  hero: {
    title: 'Ekta ítalskt bragð í hjarta Reykjavíkur',
    subtitle:
      'Upplifðu hinn sanna anda Napólí – Eldbakaðar pizzur, ferskt pasta og hlýleg þjónusta á besta ítalska veitingastað borgarinnar.',
    buttons: {
      bookTable: 'Bóka borð',
      exploreMenu: 'Skoða matseðil',
    },
  },
  aboutPreview: {
    title: 'Sagan okkar',
    subtitle:
      'Stofnað í Napólí árið 1997, Rossopomodoro kemur með ekta ítalskt bragð til miðbæjarins.',
    since: 'Síðan 2006',
    content: [
      'Hjá Rossopomodoro erum við ástríðufull fyrir að deila ekta bragði Napólí í hjarta höfuðborgarinnar. Kokkarnir okkar fylgja hefðbundnum aðferðum og nýta aðeins úrvals hráefni, flutt inn beint frá Ítalíu og blandað saman við besta sem Ísland hefur upp á að bjóða. Úr verður ekta ítölsk matargerð hér í Reykjavík..',
      'Hver pizza er útbúin samkvæmt ströngum reglum napólskrar pizzugerðarhefðar og bökuð í eldofni sem brennir eingöngu eldivið. Í tvo áratugi höfum við boðið upp á það sem margir telja bestu pizzur borgarinnar. Pastað okkar er gert ferskt á hverjum degi og vínin eru vandlega valin til að fullkomna einstakt bragð upplifunarinnar.',
    ],
    button: 'Lærðu meira um okkur',
  },
  infoOverview: {
    location: {
      title: 'Finndu okkur',
      getDirections: 'Fá leiðbeiningar',
    },
    menuStats: {
      title: 'Matseðillinn okkar',
      subtitle: 'Ekta ítalskir réttir gerðir ferskir daglega',
      pizzas: {
        category: 'Eldbakaðar pizzur',
        count: '17',
      },
      pasta: {
        category: 'Tveir áratugir reynslu',
        count: 'Est. 2006',
      },
      other: {
        category: 'Ánægðir viðskiptavinir',
        count: 'infinity',
      },
    },
    hours: {
      title: 'Opnunartími',
      openStatus: 'Við erum opin!',
      closedStatus: 'Við erum lokuð',
      openTill: 'Opin til',
      opensNext: 'Opnum',
      today: 'í dag klukkan',
      tomorrow: 'á morgun klukkan',
      at: 'klukkan',
      callUs: 'Hringdu í okkur: +354 561 0500',
      schedule: {
        weekdays: 'Mánudagur - Laugardagur',
        weekdaysTime: '12:00 - 22:00',
        sunday: 'Sunnudagur',
        sundayTime: '17:00 - 22:00',
      },
    },
  },
  menuPreview: {
    title: 'Hápunktar matseðilsins',
    subtitle: 'Upplifðu vinsælustu réttina okkar og og leyfðu bragðlaukunum að njóta!',
    button: 'Skoða matseðil',
  },
  testimonials: {
    title: 'Gestirnir segja sitt',
    subtitle: ' ',
    readMore: {
      text: 'Lestu fleiri umsagnir frá gestum okkar:',
      facebook: 'Facebook umsagnir',
      google: 'Google umsagnir',
    },
  },
  reservation: {
    title: 'Bókaðu borðið þitt',
    subtitle: 'Tryggðu þér borð í dag – við hlökkum til að bjóða þér upp á ekta ítalska upplifun',
    description:
      'Hvort sem það er rómantískt kvöldverður, fjölskyldusamkoma eða viðskiptalunch, við erum hér til að gera tilefnið þitt sérstakt.',
    form: {
      guestInfoTitle: 'Upplýsingar um gesti',
      reservationDetailsTitle: 'Upplýsingar um bókun',
      name: 'Fullt nafn',
      email: 'Netfang',
      phone: 'Símanúmer (valfrjálst)',
      guests: 'Fjöldi gesta',
      date: 'Dagsetning',
      time: 'Tími',
      note: 'Bæta við athugasemd (valfrjálst)',
      button: 'Panta borð',
      submitting: 'Bóka...',
      confirmation:
        'Bókunarbeiðnin þín hefur verið send. Við munum staðfesta bókunina þína fljótlega með tölvupósti!',
      defaultNote: 'Þú munt fá staðfestingarpóst þegar bókunin þín hefur verið staðfest.',
      errorMessage: 'Mistókst að senda bókunarbeiðni. Vinsamlegast reyndu aftur síðar.',
      placeholders: {
        name: 'Nafnið þitt',
        email: 'Netfangið þitt',
        phone: 'Símanúmerið þitt',
        date: 'Veldu þína æskilegu dagsetningu',
        note: 'Sérstakar óskir, fæðuþarfir eða upplýsingar um hátíðarhöld...',
      },
      timeOptions: {
        select: 'Veldu tíma',
      },
      guestOptions: {
        guest: 'Gestur',
        guests: 'Gestir',
        nineplus: '9+ Gestir',
      },
    },
  },
};
